import { type OrchestratedCommonListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage, interpUri } from '@b-stock/fe-core/bstock-react'

import useAccountId from '@/buyer-portal/helpers/useAccountId'

import { FixedTermsOrderDetailsButton } from './FixedTermsOrderDetailsButton'
import { ButtonContainer, StyledButtonLink } from './styledComponents'

const ns = 'Listing.actionColumn.fulfillmentListing'

export const FulfillmentActionColumn = ({
  listing,
}: {
  listing: OrchestratedCommonListingDetails
}) => {
  const accountId = useAccountId()

  return (
    <ButtonContainer>
      {listing.contract &&
      accountId &&
      accountId === listing.contract.buyerAccountId ? (
        <StyledButtonLink
          href={interpUri`/user/${accountId}/contracts/details/${listing.contract.groupId}`}
        >
          <FormattedMessage id={`${ns}.viewContract`} />
        </StyledButtonLink>
      ) : null}
      <FixedTermsOrderDetailsButton listing={listing} />
    </ButtonContainer>
  )
}
